import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import { LoadingIndicator } from '@components';
import { getContratos } from '../../../../store/loan/thunks';

import { Alerta } from './Alerta';
import { Contrato } from './contrato';

const ListaContratosAbertos = () => {
  const dispatch = useDispatch();
  const {
    listagemContratos,
    informacoesGerais: { totalParcelasEmAtraso },
    loading,
  } = useSelector((state) => state.loan.contratos);

  useEffect(() => {
    dispatch(getContratos());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-body">
        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            {totalParcelasEmAtraso > 0 && (
              <>
                <Alerta />
                <hr />
              </>
            )}
            {listagemContratos.map((contrato) => (
              <Fragment key={contrato.contrato}>
                <Contrato contrato={contrato} />
              </Fragment>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export const ContratosAbertos = () => {
  const [shouldShowSubPage, setShouldShowSubPage] = useState(false);
  const params = useParams();

  useEffect(() => {
    setShouldShowSubPage(!!params?.id);
  }, [params?.id]);

  return shouldShowSubPage ? <Outlet /> : <ListaContratosAbertos />;
};
